<div class="page-wrapper chiller-theme toggled" [ngStyle]="commonservice.showTour">
  <main class="page-content">
    <div class="bgColor">
      <div class="container">
        <div class="row" style="height: 4em;">
          <div class="col-md-6">
            <p class="appTitle">Degree Type</p>
          </div>
          <div class="col-md-6">
            <p class="adminName d-flex align-items-center justify-content-end">
              <span class="me-2">{{ adminName }}</span>
              <img
                width="30"
                height="30"
                 src="assets/tenant-avatar.jpg"
                class="rounded-circle"
                alt="Admin Avatar"
              />
            </p>
          </div>
        </div>

        <!-- 🔍 New Search Box with Reset inside -->
        <div class="row my-3 align-items-center">
          <div class="col-md-6">
            <div class="search-wrapper position-relative">
              <input
                class="form-control search-input"
                (input)="onChangeEvent($event)"
                type="text"
                placeholder="🔍 Search Degree Type..."
                [(ngModel)]="searchval"
              />
              <button
                class="clear-btn"
                *ngIf="searchval"
                (click)="reset()"
                type="button"
              >
                ✖
              </button>
            </div>
          </div>
          <div class="col-md-6 text-end">
            <button
              type="button"
              class="btn btn-primary addCourseBtn"
              (click)="openAdd()"
            >
              <i class="fa fa-plus" aria-hidden="true"></i> Add Degree Type
            </button>
          </div>
        </div>

        <div class="row" *ngIf="showData">
          <div
            class="col-md-4 degreeContent"
            *ngFor="let degreeType of allDegreeType"
          >
            <p style="text-align: left">
              {{ degreeType.type }}
              <i
                class="fa fa-trash-o iconEdit"
                (click)="deleteDegreeType(degreeType)"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-pencil iconEdit"
                (click)="editDegreeType(degreeType)"
                aria-hidden="true"
              ></i>
            </p>
          </div>
        </div>

        <div class="noData" *ngIf="showNodata">
          <h2>Currenly No Data Available!</h2>
        </div>
      </div>

      <!-- Add/Edit Modal -->
      <div class="backdrop" [ngStyle]="{ display: display }"></div>
      <div
        class="modal"
        id="successModel"
        tabindex="-1"
        role="dialog"
        [ngStyle]="{ display: display }"
      >
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header" *ngIf="showAdd">
              Add Degree Type
              <button
                type="button"
                class="close"
                aria-label="Close"
                (click)="onCloseHandled()"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-header" *ngIf="showEdit">
              Edit Degree Type
              <button
                type="button"
                class="close"
                aria-label="Close"
                (click)="onCloseHandled()"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="dltmodal-content animate modal-body dltBl">
              <form [formGroup]="degreeTypeForm">
                <label>Degree Type</label>
                <input
                  type="text"
                  class="form-control"
                  formControlName="degreeTypeName"
                  [(ngModel)]="degreeType"
                />
                <div class="error-messages">
                  <div *ngFor="let error of error_messages.degreeTypeName">
                    <div
                      class="error-message"
                      *ngIf="
                        degreeTypeForm.get('degreeTypeName').hasError(error.type) &&
                        (degreeTypeForm.get('degreeTypeName').dirty ||
                          degreeTypeForm.get('degreeTypeName').touched)
                      "
                    >
                      {{ error.message }}
                    </div>
                  </div>
                </div>

                <div class="addBtn" *ngIf="showAdd">
                  <button
                    class="commonBtn mt-2"
                    [disabled]="!degreeTypeForm.valid"
                    (click)="addDegreeType()"
                  >
                    Add Degree Type
                  </button>
                </div>
                <div class="addBtn" *ngIf="showEdit">
                  <button
                    class="commonBtn mt-2"
                    [disabled]="!degreeTypeForm.valid"
                    (click)="updateDegreeType()"
                  >
                    Update
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <!-- Delete Modal -->
      <div class="backdrop" [ngStyle]="{ display: displayDelete }"></div>
      <div
        class="modal"
        id="successModel"
        tabindex="-1"
        role="dialog"
        [ngStyle]="{ display: displayDelete }"
      >
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <button
                type="button"
                class="close"
                aria-label="Close"
                (click)="onCloseHandled()"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div
              class="dltmodal-content animate modal-body dltBl mb-3"
              style="text-align: center"
            >
              <p>Do you want to delete Degree Type ?</p>
              <button
                type="submit"
                class="btn btn-success"
                (click)="delete()"
                style="width: 20%"
              >
                Yes
              </button>
              <button
                type="submit"
                class="btn btn-danger"
                (click)="onCloseHandled()"
                style="width: 20%; margin-left: 0.3em"
              >
                No
              </button>
              <br /><br />
              <p class="error" *ngIf="showErr">{{ deleteErr }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</div>
